import TrelloMarkdown from '@atlassian/trello-markdown'
import _ from 'underscore'

import auth from 'db/auth'
import audienceDefinitions from 'lib/experiments/audience-definitions'
import TrelloEmoji from 'data/emoji'
import locales from 'data/supported-locales'
import tips from 'data/tips'
import ldclient from 'lib/ldclient'
import Util from 'lib/util'
import Accounts from 'lib/accounts'
import ClientConfig from 'debug/client-config'
import simpleTest from 'lib/experiments/simple-test'

import Interceptor from '../interceptor'
import * as ClassicApp from './classic'

function loadGamma() {
  return import(/* webpackChunkName: "gamma" */ 'gamma');
}

export function bootstrap(props) {
  return loadGamma().then(gamma => {
    ClassicApp.removeElem();

    return gamma.bootstrap(props, {
      auth,
      audienceDefinitions,
      Accounts,
      ClientConfig,
      data: {
        tips,
        locales,
        TrelloEmoji,
      },
      simpleTest,
      TrelloMarkdown,
      Util: {
        smallestPreviewBiggerThan: Util.smallestPreviewBiggerThan.bind(Util),
      },
    });
  });
}

export function mount(props) {
  return loadGamma().then(gamma => {
    ClassicApp.removeElem()
    $('#root').css({ display: 'block' })
    Interceptor.setGamma(gamma)

    return gamma.mount(props)
  });
}

export function unmount() {
  return Promise.resolve();
}

export const timeouts = {
  bootstrap: { millis: 5000 },
  mount: { millis: 5000 },
  unmount: { millis: 5000 },
  unload: { millis: 5000 },
};



// WEBPACK FOOTER //
// ./app/scripts/singlespa/apps/gamma.js